"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rvt = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const RvtSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#CAD0E4",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__a)",
    fillRule: "evenodd",
    d: "m15.167 9.9-.255 1.931-1.796.373 4.643 4.913-.949 1.44-6.608-3.524-.77 3.776-2.364-.633.711-4.685.34-1.779.525-4.405 3.592-1.92z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__b)",
    fillRule: "evenodd",
    d: "M12.235 5.387 15.167 9.9l-2.491-.944z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__c)",
    fillRule: "evenodd",
    d: "m14.912 11.83.255-1.93-2.491-.945.44 3.249z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__d)",
    fillRule: "evenodd",
    d: "m17.759 17.117-4.643-4.913-2.623.89-.29 1.939 6.607 3.524z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__e)",
    fillRule: "evenodd",
    d: "m10.493 13.093.696-2.973 1.928 2.083z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__f)",
    fillRule: "evenodd",
    d: "m12.235 5.387-1.097 4.756 1.979 2.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#25285F",
    fillRule: "evenodd",
    d: "m8.644 7.307 2.541 2.812.353-1.59z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__g)",
    fillRule: "evenodd",
    d: "m8.118 11.712.525-4.405 2.542 2.812-.692 2.974z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#1E1C4E",
    fillRule: "evenodd",
    d: "m12.236 5.387-3.592 1.92 2.894 1.223z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#272F69",
    fillRule: "evenodd",
    d: "m10.493 13.093-1.155 1.592.864.348z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__h)",
    fillRule: "evenodd",
    d: "m10.202 15.033-.77 3.776-2.364-.633 2.27-3.49z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__i)",
    fillRule: "evenodd",
    d: "M9.338 14.685 7.78 13.491l-.711 4.684z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__j)",
    fillRule: "evenodd",
    d: "m7.78 13.491 2.713-.398-1.155 1.592z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#121325",
    fillRule: "evenodd",
    d: "m7.78 13.491.338-1.779 2.375 1.381z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "url(#rvt__k)",
    fillRule: "evenodd",
    d: "m12.698 8.968-1.16-.438.697-3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__a",
      x1: 13.451,
      x2: 9.182,
      y1: 18.531,
      y2: 12.55,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#293D7B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.995,
        stopColor: "#263A7D"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__b",
      x1: 13.89,
      x2: 12.75,
      y1: 9.806,
      y2: 7.848,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#293D7B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.995,
        stopColor: "#263A7D"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__c",
      x1: 14.345,
      x2: 13.027,
      y1: 11.876,
      y2: 9.734,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#2F4687"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#224083"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__d",
      x1: 12.954,
      x2: 14.507,
      y1: 16.396,
      y2: 14.189,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.005,
        stopColor: "#27397C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#253C7F"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__e",
      x1: 11.845,
      x2: 11.443,
      y1: 12.888,
      y2: 11.043,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#201D50"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#24285D"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__f",
      x1: 12.226,
      x2: 12.073,
      y1: 8.959,
      y2: 8.92,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#272C66"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#27326F"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__g",
      x1: 9.48,
      x2: 10.196,
      y1: 12.35,
      y2: 9.424,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#14133E"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#212053"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__h",
      x1: 8.353,
      x2: 9.664,
      y1: 18.708,
      y2: 15.969,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#283270"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#27397C"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__i",
      x1: 7.947,
      x2: 9.044,
      y1: 17.788,
      y2: 14.978,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#272962"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#262860"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__j",
      x1: 9.204,
      x2: 9.181,
      y1: 14.139,
      y2: 13.682,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 0.005,
        stopColor: "#212053"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#232459"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "rvt__k",
      x1: 12.118,
      x2: 12.219,
      y1: 8.767,
      y2: 6.866,
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        stopColor: "#27316D"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#28326F"
      })]
    })]
  })]
});
const Rvt = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: RvtSvg
}));
exports.Rvt = Rvt;